var map = {
	"./Mitsubachi Notebooks.jpg": 22,
	"./Mitsubachi-1.jpg": 88,
	"./Mitsubachi-3.jpg": 89,
	"./Mitsubachi-4.jpg": 90,
	"./Mitsubachi-6.jpg": 91,
	"./Mitsubachi-61.gif": 92,
	"./Mitsubachi-7.jpg": 93,
	"./Mitsubachi-8.jpg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;